import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const editingSignature = {
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.EDITING_SIG.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.EDITING_SIG.DESCRIPTION')
  }
};
